import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-product-image-dialog',
  templateUrl: './product-image-dialog.component.html',
  styleUrls: ['./product-image-dialog.component.scss']
})
export class ProductImageDialogComponent implements OnInit {
  mainImgUrl: string = "";
  constructor(
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<ProductImageDialogComponent>,
    private alertService: AlertService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { 
    this.mainImgUrl = this.data;
  }

  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }
}
